import { xoxoApi, kioskApi, API_KEY } from '../axios.js';
// Removed duplicate import
export const recipeApi = {
    getAdminRecipes(shopId) {
        return kioskApi.get(`/admin/shops/${shopId}/recipes`);
    },
    cacheRecipes(recipes) {
        return kioskApi.post('/admin/recipes/cache', { recipes }).then((res) => res.data);
    },
    /**
     * Fetch a single recipe by ID from the kiosk backend
     */
    getRecipeById(recipeId) {
        return kioskApi.get(`/admin/recipes/${recipeId}`);
    },
    /**
     * Fetch multiple recipes by their IDs
     */
    getRecipesByIds(recipeIds) {
        return kioskApi.post('/admin/recipes/batch', { recipeIds });
    }
};
export const xoxoRecipeApi = {
    /**
     * Fetches admin recipes from XOXO API using shop name
     * @param shopName - The name of the shop to fetch recipes for
     */
    getAdminRecipes(shopName) {
        return xoxoApi.get('/recipe/admin/withDrinkFeature', {
            params: { shopName, apiKey: API_KEY },
        });
    }
};
